const SET_SLIDER_CONTENT = (state, content) => {
    state.sliderContent = (content !== undefined) ? content : false;
}
const SET_SLIDER_VISIBILITY = (state, visible) => {
    state.hasSlider = visible;
    state.sliderActive = visible;
}
const SET_ACTIVE_SLIDE_ID = (state, id) => {
    state.activeSlideID = id;
}

export default {
    SET_SLIDER_CONTENT,
    SET_SLIDER_VISIBILITY,
    SET_ACTIVE_SLIDE_ID
}


// WEBPACK FOOTER //
// ./src/store/slider/mutations.js